import {defineMessages} from 'react-intl';

export default defineMessages({
	emailLabel: {
		id: 'forms.fields.email.labels.optional',
		defaultMessage: 'Email',
	},
	emailNotFound: {
		id: 'forms.fields.email.noempty',
		defaultMessage: 'Please enter your email address',
	},
	emailIsInvalid: {
		id: 'forms.fields.email.noinvalid',
		defaultMessage: 'Please enter a valid email address',
	},
	passwordLabel: {
		id: 'forms.fields.password.placeholder',
		defaultMessage: 'Password',
	},
	passwordNotFound: {
		id: 'forms.fields.password.noempty',
		defaultMessage: 'Please enter your password',
	},
});
